import { Link } from 'react-router-dom';
import styles from './FaleConosco.module.scss';

export default function FaleConosco() {
    return (
        <section className={styles.contact_container}>
            <div className={styles.contact}>
                <div className={styles.contact_text}>
                    <h2>Venha e traga o seu projeto</h2>
                    <p>
                        Podemos ajudar a desenhar o seu projeto, entregando eficiência e resultados.
                    </p>
                </div>
                <button>
                    <Link to="/contato">Fale com um especialista</Link>
                </button>
            </div>
            <div className={styles.overlay}></div>
        </section>
    );
}
